import getOffset from 'root/src/shared/util/getOffset'
import displaySaveMessage from 'root/src/client/logic/form/util/displaySaveMessage'

export default async (onExit, dispatcher, e) => {
	if (onExit) {
		const position = getOffset(e.target)
		await dispatcher(onExit)
		displaySaveMessage(dispatcher, position)
	}
}
